<template lang="pug">
.mobile-slider
  .c-keen-slider-image-viewer
    button.keen-slider-prev(@click="featuredSlider.prev()") Previous
    #js-slider.c-keen-slider-main-image.keen-slider(ref="featured_slider")
      .keen-slider__slide.sku_image(v-if="skuImage", v-cloak)
        img.js-slider-image(:src='getImageSrc(skuImage.src)', :alt="skuImage.alt", :title="skuImage.alt", @click="openImage(skuImage)", :width="skuImage.width", :height="skuImage.height", v-cloak)

      .keen-slider__slide(v-for="(item, index) in imageObjects", v-cloak)
        img.js-slider-image(:src='getImageSrc(`${conf.path.resize}ex/${item.images.o.width}.${item.images.o.height}${item.source}`)', :alt="getImageAlt(item.alternate_text, index)", :title="getImageAlt(item.alternate_text, index)", @click="openImage(item)", :width="item.images.o.width", :height="item.images.o.height", v-cloak)
    button.keen-slider-next(@click="featuredSlider.next()") Next

    .image-overlay(v-if="selectedImage" @click="closeImage")
    .image-content(v-if="selectedImage" @click.stop="closeImage")
      template(v-if="selectedImage.images")
        img(:src='`${conf.path.resize}ex/${selectedImage.images.o.width}.${selectedImage.images.o.height}${selectedImage.source}`', :alt="getImageAlt(selectedImage.alternate_text)", width="100%")
      template(v-else)
        img(:src='selectedImage.src', :alt="selectedImage.alt", width="100%")
</template>

<script>
import KeenSlider from 'keen-slider';
import urlUtil from '../../../util/url';

export default {
  props: [
    'mainImage',
    'mainImageObjects',
    'subImageObjects',
    'titleLabelName',
    'docTitle'
  ],
  data() {
    return {
      selectedImage: null,
      featuredSlider: null,
      sliderOptions: {
        loop: true,
        initial: 0,
        slides: {
          origin: 'center',
          perView: 1,
          spacing: 0,
        }
      },
      skuImage: null
    };
  },
  mounted() {
    this.$root.$on('refresh-slider', this.refreshSlider);

    if (this.$refs.featured_slider) {
      this.featuredSlider = new KeenSlider(this.$refs.featured_slider, this.sliderOptions);
    }
  },
  computed: {
    conf() {
      return window.tom.conf;
    },
    imageObjects() {
      if (this.mainImageObjects) {
        return [this.mainImageObjects, ...this.subImageObjects];
      } else {
        return this.subImageObjects;
      }
    }
  },
  methods: {
    openImage(item) {
      this.selectedImage = item;
      document.body.classList.add('no-scrollable');
    },
    closeImage() {
      this.selectedImage = null;
      document.body.classList.remove('no-scrollable');
    },
    getImageSrc(url) {
      return urlUtil.webp(url);
    },
    getImageAlt(text, index) {
      const altIndex = index !== undefined ? ` ${index + 1}` : '';
      const altSuffix = this.titleLabelName ? (' ' + this.titleLabelName) : '';

      if (text) {
        return `${text + altIndex}`;
      }

      return `${this.docTitle + altSuffix + altIndex}`;
    },
    refreshSlider(data) {
      this.skuImage = data;
      this.featuredSlider.destroy();
      this.$nextTick(() => {
        this.featuredSlider = new KeenSlider(this.$refs.featured_slider, this.sliderOptions);
      });
    }
  }
};
</script>

<style scoped>
.c-keen-slider-image-viewer {
  height: 100vw;
  overflow: hidden;
  background: #f0f0f0 url("https://dzt1km7tv28ex.cloudfront.net/static/shop/product_no_image.png") center no-repeat;
  position: relative;
}

.c-keen-slider-main-image {
  background: transparent;
  background-size: contain;
  height: 100%;
}

.keen-slider__slide {
  width: 100vw;
  min-width: 100vw;
  transform: translate3d(0px, 0px, 0px);
  display: flex;
  background: #fff;
  align-items: flex-start;
}

.keen-slider__slide img {
  width: 100vw;
  height: 100vw;
  object-fit: cover;
  object-position: top;
}

.keen-slider-prev, .keen-slider-next {
  display: block;
  width: 40px;
  height: 40px;
  margin-top: -20px;
  padding: 5px;
  background: rgba(0, 0, 0, .2);
  font-size: 30px;
  text-align: center;
  border-radius: 50%;
  border: 1px solid #fff;
  opacity: .6;
  z-index: 2;
  line-height: 0;
  position: absolute;
  top: 50%;
  cursor: pointer;
  color: transparent;
  outline: 0;
}

.keen-slider-prev {
  left: 10px;
}

.keen-slider-next {
  right: 10px;
}

.keen-slider-prev:hover, .keen-slider-prev:focus,
.keen-slider-next:hover, .keen-slider-next:focus {
  background: rgba(0, 0, 0, .4);
}

.keen-slider-prev::before, .keen-slider-next::before {
  position: relative;
  display: block;
  font-family: tomicon;
  top: -1px;
  font-size: 20px;
  line-height: 1;
  opacity: .75;
  color: white;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.keen-slider-prev::before {
  content: "\e6e8";
}

.keen-slider-next::before {
  content:  "\e6e9";
}

.image-overlay {
  position: fixed;
  width: 100%;
  height: 100vh;
  background: rgb(0 0 0 / 75%);
  top: 0;
  left: 0;
  z-index: 999;
}
.image-content {
  height: 100vh;
  padding: 20px;
  position: fixed;
  top: 0;
  left: 0;
  align-items: center;
  z-index: 9999;
}
</style>
